import useFetchFilteredResults from 'js/hooks/use-fetch-filtered-results';

import ContentWithSidebar from 'components/content-with-sidebar/ContentWithSidebar';
import EmptyList from 'components/empty-list/EmptyList';
import FilterLayout from 'components/filter-layout/FilterLayout';
import Form from 'components/form/Form';
import Pagination from 'components/pagination/Pagination';
import Spinner from 'components/spinner/Spinner';
import CategoryListItem from 'components/category-list-item/CategoryListItem';

import { ICategoryListPage } from 'source/NFR.types';

type CategoryListFilterState = Pick<ICategoryListPage, 'emptyList' | 'filterLayout' | 'pagination' | 'groups'>;

const CategoryListPage: React.FC<ICategoryListPage> = ({
  emptyList,
  filterLayout,
  form,
  groups = [],
  title,
  pagination,
  fetchFilteredResultsEndpoint
}) => {
  const [
    isLoading,
    { emptyList: emptyListState, filterLayout: filterLayoutState, pagination: paginationState, groups: groupsState },
    fetchResults
  ] = useFetchFilteredResults<CategoryListFilterState>(
    { emptyList, filterLayout, pagination, groups },
    fetchFilteredResultsEndpoint,
    form.endpoint
  );

  return (
    <Form className="category-list-page" showSubmitButton={false} {...form}>
      <ContentWithSidebar>{title && <h1 className="category-list-page--title">{title}</h1>}</ContentWithSidebar>
      <FilterLayout {...filterLayoutState} fetchFilteredResults={fetchResults} isLoading={isLoading}>
        <>
          {groupsState && groupsState.length > 0 ? (
            groupsState?.map((group, index) => (
              <CategoryListItem key={group.cardData && group.cardData.title + index} {...group} />
            ))
          ) : (
            <EmptyList {...emptyListState} />
          )}
          <Spinner isActive={isLoading} />
        </>
        <Pagination {...paginationState} />
      </FilterLayout>
    </Form>
  );
};

CategoryListPage.displayName = 'CategoryListPage';

export default CategoryListPage;
